import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import Badge from "components/base/Badge";
import RevealDropdown, {
  RevealDropdownTrigger,
} from "components/base/RevealDropdown";
import ActionDropdownItems from "components/common/ActionDropdownItems";
import { Link } from "react-router-dom";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import { PromocaoTableType } from "data/promocoes";

const columnHelper = createColumnHelper<PromocaoTableType>();

export const promocaoTableColumns: ColumnDef<PromocaoTableType>[] = [
  {
    accessorKey: "codigo",
    header: "Código",
    meta: {
      headerProps: { style: { width: 100 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "descricao",
    header: "Descrição",
    cell: ({ row: { original } }) => {
      const { descricao, id } = original;
      return (
        <Link
          to={`/cadastros/promocoes/${id}`}
          className="fw-semibold line-clamp-3"
        >
          {descricao}
        </Link>
      );
    },
    meta: {
      headerProps: { style: { width: 350 }, className: "ps-4" },
      cellProps: { className: "ps-4" },
    },
  },
  {
    accessorKey: "tipoDesconto",
    header: "Tipo Desconto",
    cell: ({ getValue }) => {
      const value = getValue() as number;
      const tiposMap: Record<number, string> = {
        1: "Pague Leve",
        2: "Desconto Múltiplo",
      };
      return tiposMap[value] || value;
    },
  },
  {
    accessorKey: "aplicarPara",
    header: "Aplicar Para",
    cell: ({ getValue }) => {
      const value = getValue() as number;
      const tiposMap: Record<number, string> = {
        1: "Produtos",
        2: "Categorias",
        3: "Departamentos",
      };
      return tiposMap[value] || value;
    },
  },
  {
    accessorKey: "dataInicio",
    header: "Data Início",
    cell: ({ getValue }) => {
      const date = getValue() as string;
      return date ? new Date(date).toLocaleDateString("pt-BR") : "Ilimitada";
    },
  },
  {
    accessorKey: "dataFim",
    header: "Data Fim",
    cell: ({ getValue }) => {
      const date = getValue() as string;
      return date ? new Date(date).toLocaleDateString("pt-BR") : "Ilimitada";
    },
  },
  {
    accessorKey: "inativo",
    header: "Status",
    cell: ({ getValue }) => {
      const inativo = getValue() as boolean;
      return inativo ? (
        <Badge bg="danger">Inativo</Badge>
      ) : (
        <Badge bg="success">Ativo</Badge>
      );
    },
  },
];

const PromocaoTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default PromocaoTable;
